/* eslint-disable camelcase */
import React, { Component } from 'react'
import pt from 'prop-types'
import { connect } from 'react-redux'
import Search from '../icon/PickContextMenuSearch'
import DotMenu from '../icon/DotMenu'
import CollectionViewMenu from '../CollectionViewMenu/CollectionViewMenu'
import { setThumbnailType, setLayoutType } from '../../modules/viewSettings'

import ViewBarArrowUp from '../icon/ViewBarArrowUp'
import ViewBarArrowDown from '../icon/ViewBarArrowDown'
import ViewBarArrowTimeUp from '../icon/ViewBarArrowTimeUp'
import ViewBarArrowTimeDown from '../icon/ViewBarArrowTimeDown'
import ViewBarArrowAlphUp from '../icon/ViewBarArrowAlphUp'
import ViewBarArrowAlphDown from '../icon/ViewBarArrowAlphDown'
import FeedTrim from '../icon/FeedTrim'
import FeedSquare from '../icon/FeedSquare'
import FeedPoster from '../icon/FeedPoster'
import FeedStack from '../icon/FeedStack'
import FeedGrid from '../icon/FeedGrid'
import FeedGallery from '../icon/FeedGallery'
import FeedStage from '../icon/FeedStage'
import FeedOrder from '../icon/FeedOrder'
import { openHelperMod, openMod } from '../../modules/mods'

import './ViewOptionsBar.scss'

export class ViewOptionsBar extends Component {
  constructor(props) {
    super(props)

    this.state = {
      ...this.defaultState,
      feedOptionsActive: 'Created'
    }
    this.switchMenu = this.switchMenu.bind(this)
  }

  defaultState = {
    isSortMenuShown: false,
    isViewModeMenuShown: false,
    isThumbnailModeMenuShown: false,
    isContextMenuShown: false
  }

  switchMenu(e, options) {
    e.preventDefault()
    e.stopPropagation()

    if (this.state[options.state] === true) {
      return
    }

    if (options.state === false) {
      this.setState(this.defaultState)
    } else {
      this.setState(this.defaultState, () => {
        this.setState(
          {
            [options.state]: !this.state[options.state]
          },
          () => {
            window.addEventListener('click', this.onClickListener)
          }
        )
      })
    }
  }

  onClickListener = e => {
    e.preventDefault()
    e.stopPropagation()
    this.setState(this.defaultState)
  }

  switchFeedOptionsActive(options) {
    this.setState({
      feedOptionsActive: options.item
    })
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onClickListener)
  }

  render() {
    const {
      feedOptions,
      setOrder,
      isCollectionViewBarShown,
      openHelperMod,
      openMod,
      setKeyword,
      keyword,
      itemsOrder,
      type,
      isHome,
      setThumbnailType,
      setLayoutType,
      viewSettings,
      feedId
    } = this.props

    let iconSort
    switch (itemsOrder) {
      case 'custom':
        iconSort = <ViewBarArrowUp />
        break
      case 'flipped':
        iconSort = <ViewBarArrowDown />
        break
      case 'date_added':
        iconSort = <ViewBarArrowTimeUp />
        break
      case 'date_added_asc':
        iconSort = <ViewBarArrowTimeDown />
        break
      case 'name':
        iconSort = <ViewBarArrowAlphUp />
        break
      case 'name_asc':
        iconSort = <ViewBarArrowAlphDown />
        break

      default:
        iconSort = <ViewBarArrowUp />

        break
    }

    let iconViewMode
    switch (this.props.viewSettings.get('layoutType')) {
      case 'list':
        iconViewMode = <FeedStack />
        break
      case 'grid':
        iconViewMode = <FeedGrid />
        break
      case 'gallery':
        iconViewMode = <FeedGallery />
        break
      case 'stage':
        iconViewMode = <FeedStage />
        break

      default:
        break
    }

    let iconThumbnailsType

    switch (viewSettings.get('thumbnailType')) {
      case 'squared':
        iconThumbnailsType = <FeedSquare />
        break
      case 'square':
        iconThumbnailsType = <FeedSquare />
        break
      case 'trimmed':
        iconThumbnailsType = <FeedTrim />
        break
      case 'trim':
        iconThumbnailsType = <FeedTrim />
        break
      case 'poster':
        iconThumbnailsType = <FeedPoster />
        break

      default:
        break
    }

    const buttons = [
      {
        icon: iconSort,
        name: 'sort',
        state: 'isSortMenuShown'
      },
      {
        icon: iconViewMode,
        name: 'viewMode',
        state: 'isViewModeMenuShown',
        f: () => {
          switch (viewSettings.get('layoutType')) {
            case 'list':
              setLayoutType('grid')
              break
            case 'grid':
              setLayoutType('gallery')
              break
            case 'gallery':
              setLayoutType('stage')
              break
            case 'stage':
              setLayoutType('list')
              break

            default:
              break
          }
        }
      },
      {
        icon: iconThumbnailsType,
        name: 'thumbsMode',
        state: 'isThumbnailModeMenuShown',
        f: () => {
          switch (viewSettings.get('thumbnailType')) {
            case 'trim':
              setThumbnailType('squared')
              break
            case 'squared':
              setThumbnailType('poster')
              break
            case 'poster':
              setThumbnailType('trim')
              break

            default:
              break
          }
        }
      },
      {
        icon: <DotMenu />,
        name: 'context',
        state: 'isContextMenuShown',
        f: () => {
          openHelperMod({ type: 'editViewOptions' })
        }
      }
    ]
    if (isHome) {
      buttons.shift()
    }
    return (
      <div
        className={
          'collection-view-bar' +
          (isCollectionViewBarShown ? ' collection-view-bar--active' : '') +
          (type ? ' collection-view-bar--' + type : '')
        }
      >
        <div className="collection-view-bar__profile">
          {feedOptions &&
            feedOptions.map(item => {
              return (
                <div
                  className={
                    'collection-view-bar__profile-button' +
                    (item.text === this.state.feedOptionsActive ? ' collection-view-bar__profile-button--active' : '')
                  }
                  onMouseUp={() => {
                    this.switchFeedOptionsActive({ item: item.text })
                    item.action()
                  }}
                  key={item.name}
                >
                  {item.text}
                </div>
              )
            })}
        </div>
        <div className="collection-view-bar__search">
          <span className="collection-view-bar__search-icon">
            <Search />
          </span>
          <input
            placeholder="Search"
            className="collection-view-bar__search-input"
            onChange={e => {
              setKeyword(e.currentTarget.value)
            }}
            value={keyword}
          />
        </div>
        <div className="collection-view-bar__buttons">
          {buttons.map(buttonItem => {
            return (
              <div
                className={'collection-view-bar__button collection-view-bar__button--' + buttonItem.name}
                key={buttonItem.name}
                onClick={() => {
                  buttonItem.f && buttonItem.f()
                }}
                onMouseOver={e => {
                  if (buttonItem.name !== 'context') {
                    this.switchMenu(e, { state: buttonItem.state })
                  }
                }}
              >
                {this.state[buttonItem.state] ? (
                  <div className="collection-view-bar__menu">
                    <CollectionViewMenu
                      type={buttonItem.name}
                      setOrder={setOrder}
                      switchMenu={this.switchMenu}
                      itemsOrder={this.state.itemsOrder}
                    />
                  </div>
                ) : null}

                {buttonItem.icon}
              </div>
            )
          })}
          <div
            className={'collection-view-bar__button collection-view-bar__button--edit-order'}
            onClick={() => {
              openMod({ type: 'editFeedOrder', feedId: feedId })
            }}
          >
            <FeedOrder />
          </div>
        </div>
      </div>
    )
  }
}

ViewOptionsBar.propTypes = {
  setOrder: pt.func,
  openHelperMod: pt.func,
  openMod: pt.func,
  isCollectionViewBarShown: pt.bool,
  viewSettings: pt.object,
  setKeyword: pt.func,
  keyword: pt.string,
  itemsOrder: pt.string,
  type: pt.string,
  isHome: pt.bool,
  setThumbnailType: pt.func,
  setLayoutType: pt.func,
  feedOptions: pt.array,
  feedId: pt.string
}

const makeMapStateToProps = () => {
  return (state, props) => {
    return {
      viewSettings: state.viewSettings,
      feedId:
        state.location.pathname
          .split('/')
          .pop()
          .split('----')[0] || undefined
    }
  }
}

export default connect(
  makeMapStateToProps,
  { openMod, openHelperMod, setLayoutType, setThumbnailType }
)(ViewOptionsBar)
